import { APP_PERMISSIONS } from '@exam-center/permission';

import { type AppMenuConfig } from '../../types';

const SIDEBAR_ITEMS: AppMenuConfig[] = [
  {
    section: '',
    items: [
      {
        label: 'หน้าหลัก',
        url: '/:examCenterCode/home',
        iconName: 'HOME',
      },
      {
        label: 'ข้อมูลศูนย์ทดสอบ',
        url: '/:examCenterCode/details',
        iconName: 'EXAM_CENTERS',
        permission: {
          requiredPermission: [
            APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW,
            APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW,
            APP_PERMISSIONS.EXAM_CENTER_MANAGEMENT.MEMBER.VIEW,
          ],
          operator: 'OR',
        },
      },
      {
        label: 'จัดการตารางสอบ',
        url: '/:examCenterCode/exam-events',
        iconName: 'EXAM_EVENTS',
        permission: {
          requiredPermission: [
            APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAM_EVENT.VIEW,
            APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.EXAMINEES.VIEW,
            APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.RESULTS.VIEW,
            APP_PERMISSIONS.EXAM_EVENT_MANAGEMENT.AUDIT_LOG.VIEW,
          ],
          operator: 'OR',
        },
      },
      {
        label: 'จัดการทดสอบ',
        url: '/:examCenterCode/proctoring',
        iconName: 'PROCTORING',
        permission: {
          requiredPermission: [
            APP_PERMISSIONS.PROCTORING.DETAILS.VIEW,
            APP_PERMISSIONS.PROCTORING.REGISTRATION.VIEW,
            APP_PERMISSIONS.PROCTORING.E_KYC.VIEW,
          ],
          operator: 'OR',
        },
      },
      {
        label: 'จัดการสถานที่สอบ',
        url: '/:examCenterCode/exam-location',
        iconName: 'EXAM_LOCATION',
        permission: {
          requiredPermission: [
            APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
            APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
            APP_PERMISSIONS.EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW,
          ],
          operator: 'OR',
        },
      },
      {
        label: 'จัดการผู้คุมสอบ',
        url: '/:examCenterCode/exam-proctors',
        iconName: 'PROCTORS',
        permission: {
          requiredPermission: [
            APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR.VIEW,
            APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
            APP_PERMISSIONS.PROCTOR_MANAGEMENT.PROCTOR_EXPIRATION.VIEW,
          ],
          operator: 'OR',
        },
      },
    ],
  },
  {
    section: 'Admin Tools',
    items: [
      {
        label: 'Admin',
        iconName: 'ADMIN',
        url: '/admin', // TODO: Fix types for Nav Menu Item
        subMenu: [
          {
            label: 'จัดการศูนย์ทดสอบ',
            url: '/admin/exam-centers',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_CENTER.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.EXAM_COURSE.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_CENTER_MANAGEMENT.MEMBER.VIEW,
              ],
              operator: 'OR',
            },
          },
          {
            label: 'จัดการหลักสูตร',
            url: '/admin/exam-courses',
            permission: {
              requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_COURSE_MANAGEMENT.SETTINGS.VIEW],
            },
          },
          {
            label: 'มอบหมายชุดข้อสอบ',
            url: '/admin/exam-distribution',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.AVAILABLE_QSETS.VIEW,
              ],
              operator: 'OR',
            },
          },
          {
            label: 'จัดการผู้คุมสอบ',
            url: '/admin/exam-proctors',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.VIEW,
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.VIEW,
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.VIEW,
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_EXPIRATION.VIEW,
                APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.AUDIT_LOG.VIEW,
              ],
              operator: 'OR',
            },
          },
          {
            label: 'จัดการสถานที่สอบ',
            url: '/admin/exam-location',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_REQUEST.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT
                  .EXAM_LOCATION_REQUEST_FIRST_TIER_REVIEW.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT
                  .EXAM_LOCATION_REQUEST_SECOND_TIER_REVIEW.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_CANCELATION.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.AUDIT_LOG.VIEW,
                APP_PERMISSIONS.ADMIN_EXAM_LOCATION_MANAGEMENT.EXAM_LOCATION_USAGE.VIEW,
              ],
              operator: 'OR',
            },
          },
          {
            label: 'รายชื่อผู้ไม่มีสิทธิ์สอบ',
            url: '/admin/blocklist',
            permission: {
              requiredPermission: [APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.VIEW],
            },
          },
          {
            label: 'ประกาศข่าวสาร',
            url: '/admin/web-register-announcements',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_ANNOUNCEMENT_MANAGEMENT.WEB_REGISTER_ANNOUNCEMENT.VIEW,
              ],
            },
          },
          {
            label: 'แบบสอบถาม',
            url: '/admin/questionnaires',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_QUESTIONNAIRE_MANAGEMENT.QUESTIONNAIRE_REPORT.VIEW,
              ],
            },
          },
          {
            label: 'รายการไฟล์ผลการสอบ',
            url: '/admin/exam-result-files',
            permission: {
              requiredPermission: [
                APP_PERMISSIONS.ADMIN_SET_PORTAL_MANAGEMENT.EXAM_RESULT_FILE.VIEW,
              ],
            },
          },
        ],
      },
    ],
  },
];

export function useGetSidebarItems() {
  return SIDEBAR_ITEMS;
}
